import { CreateAlertConfigType } from 'src/components/BeaconV2Components/ExperimentalLayout/Settings/Alerts/schema/AlertBuilderSchemaTypes';
import { AtlasAlertTemplateIdType, BeaconAlertTemplateIdType } from './TemplateSchema';
import { AppName } from 'sl-api-connector';

export const AtlasNewProductLaunchJson: CreateAlertConfigType = {
  alertName: 'New Product Launch',
  alertDescription: '',
  queryJSON: {
    basicInfo: {
      selectedProduct: 'atlas',
      granularity: ['CategoryId', 'RetailerId', 'RetailerSku'],
      frequency: 'weekly'
    },
    globalFilters: [
      {
        type: 'Category',
        concept: 'categoryid',
        operator: 'IN',
        values: []
      },
      {
        type: 'Retailer',
        concept: 'retailerid',
        operator: 'IN',
        values: []
      }
    ],
    rules: {
      ruleGroups: [
        {
          ruleBlocks: [
            {
              metric: 'Retail Sales',
              aggregation: 'sum',
              timeConfiguration: {
                mode: 'For the First Time',
                forTheFirstTimeOption: 'Last Week'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Category',
                  concept: 'categoryid'
                }
              ],
              metricFilter: {
                operator: '>',
                value: 10000
              }
            }
          ],
          operators: []
        }
      ],
      groupOperators: []
    }
  },
  notifications: {
    methods: [],
    config: {}
  }
};

export const AtlasNewProductEntersTop10Json: CreateAlertConfigType = {
  alertName: 'New Product Enters Top 10',
  alertDescription: '',
  queryJSON: {
    basicInfo: {
      selectedProduct: 'atlas',
      granularity: ['CategoryId', 'RetailerId', 'RetailerSku'],
      frequency: 'weekly'
    },
    globalFilters: [
      {
        type: 'Category',
        concept: 'categoryid',
        operator: 'IN',
        values: []
      },
      {
        type: 'Retailer',
        concept: 'retailerid',
        operator: 'IN',
        values: []
      }
    ],
    rules: {
      ruleGroups: [
        {
          ruleBlocks: [
            {
              metric: 'Retail Sales',
              aggregation: 'sum',
              timeConfiguration: {
                mode: 'For the First Time',
                forTheFirstTimeOption: 'Last Week'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Category',
                  concept: 'categoryid'
                }
              ],
              metricFilter: {
                operator: 'ranked_in_top',
                rankLimit: 10
              }
            }
          ],
          operators: []
        }
      ],
      groupOperators: []
    }
  },
  notifications: {
    methods: [],
    config: {}
  }
};

export const AtlasSalesCrossThresholdJson: CreateAlertConfigType = {
  alertName: 'Sales Cross Threshold',
  alertDescription: '',
  queryJSON: {
    basicInfo: {
      selectedProduct: 'atlas',
      granularity: ['RetailerId', 'BrandId'],
      frequency: 'weekly'
    },
    globalFilters: [
      {
        type: 'Category',
        concept: 'categoryid',
        operator: 'IN',
        values: []
      },
      {
        type: 'Retailer',
        concept: 'retailerid',
        operator: 'IN',
        values: []
      }
    ],
    rules: {
      ruleGroups: [
        {
          ruleBlocks: [
            {
              metric: 'Retail Sales',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'Predefined Period',
                timeRange: 'Last 4 Weeks'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Brand',
                  concept: 'brandid'
                }
              ]
            },
            {
              metric: 'Retail Sales',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'Predefined Period',
                timeRange: 'Last 4 Weeks'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Brand',
                  concept: 'brandid'
                }
              ]
            }
          ],
          operators: [
            {
              type: 'greater than',
              threshold: {
                value: 0,
                unit: '$'
              }
            }
          ]
        }
      ],
      groupOperators: []
    }
  },
  notifications: {
    methods: [],
    config: {}
  }
};

export const AtlasSalesDropThresholdJson: CreateAlertConfigType = {
  alertName: 'Sales Drop Threshold',
  alertDescription: '',
  queryJSON: {
    basicInfo: {
      selectedProduct: 'atlas',
      granularity: ['RetailerId', 'BrandId'],
      frequency: 'weekly'
    },
    globalFilters: [
      {
        type: 'Category',
        concept: 'categoryid',
        operator: 'IN',
        values: []
      },
      {
        type: 'Retailer',
        concept: 'retailerid',
        operator: 'IN',
        values: []
      }
    ],
    rules: {
      ruleGroups: [
        {
          ruleBlocks: [
            {
              metric: 'Retail Sales',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'Predefined Period',
                timeRange: 'Last Week'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Brand',
                  concept: 'brandid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                }
              ]
            },
            {
              metric: 'Retail Sales',
              aggregation: 'avg',

              timeConfiguration: {
                mode: 'Predefined Period',
                timeRange: 'Last 4 Weeks'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Brand',
                  concept: 'brandid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                }
              ]
            }
          ],
          operators: [
            {
              type: 'less than',
              threshold: {
                value: 15,
                unit: '%'
              }
            }
          ]
        }
      ],
      groupOperators: []
    }
  },
  notifications: {
    methods: [],
    config: {}
  }
};

export const AtlasBrandEntersTop10SalesJson: CreateAlertConfigType = {
  alertName: 'Brand Enters Top 10 Sales',
  alertDescription: '',
  queryJSON: {
    basicInfo: {
      selectedProduct: 'atlas',
      granularity: ['RetailerId', 'BrandId'],
      frequency: 'weekly'
    },
    globalFilters: [
      {
        type: 'Category',
        concept: 'categoryid',
        operator: 'IN',
        values: []
      },
      {
        type: 'Retailer',
        concept: 'retailerid',
        operator: 'IN',
        values: []
      }
    ],
    rules: {
      ruleGroups: [
        {
          ruleBlocks: [
            {
              metric: 'Retail Sales',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'For the First Time',
                forTheFirstTimeOption: 'Last Week'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Brand',
                  concept: 'brandid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                }
              ],
              metricAdjustment: {
                operation: 'Divide by',
                useReferenceFilter: true,
                referenceFilters: [
                  {
                    type: 'Retailer',
                    operator: 'IN',
                    values: [],
                    concept: 'retailerid'
                  }
                ]
              },
              metricFilter: {
                operator: 'ranked_in_top',
                rankLimit: 10
              }
            }
          ],
          operators: []
        }
      ],
      groupOperators: []
    }
  },
  notifications: {
    methods: [],
    config: {}
  }
};

export const AtlasMarketShareThresholdJson: CreateAlertConfigType = {
  alertName: 'Market Share Threshold',
  alertDescription: '',
  queryJSON: {
    basicInfo: {
      selectedProduct: 'atlas',
      granularity: ['RetailerId', 'BrandId', 'CategoryId'],
      frequency: 'weekly'
    },
    globalFilters: [
      {
        type: 'Category',
        concept: 'categoryid',
        operator: 'IN',
        values: []
      },
      {
        type: 'Retailer',
        concept: 'retailerid',
        operator: 'IN',
        values: []
      }
    ],
    rules: {
      ruleGroups: [
        {
          ruleBlocks: [
            {
              metric: 'Retail Sales',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'Predefined Period',
                timeRange: 'Last Week'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Category',
                  concept: 'categoryid'
                }
              ],
              metricAdjustment: {
                operation: 'Divide by',
                useReferenceFilter: true,
                referenceFilters: [
                  {
                    type: 'Retailer',
                    operator: 'IN',
                    values: [],
                    concept: 'retailerid'
                  },
                  {
                    type: 'Category',
                    operator: 'IN',
                    values: [],
                    concept: 'categoryid'
                  }
                ]
              },
              metricFilter: {
                operator: '>',
                value: 0.15
              }
            }
          ],
          operators: []
        }
      ],
      groupOperators: []
    }
  },
  notifications: {
    methods: [],
    config: {}
  }
};

export const AtlasMarketShareChangeJson: CreateAlertConfigType = {
  alertName: 'Market Share Change',
  alertDescription: '',
  queryJSON: {
    basicInfo: {
      selectedProduct: 'atlas',
      granularity: ['RetailerId', 'BrandId', 'CategoryId'],
      frequency: 'weekly'
    },
    globalFilters: [
      {
        type: 'Category',
        concept: 'categoryid',
        operator: 'IN',
        values: []
      },
      {
        type: 'Retailer',
        concept: 'retailerid',
        operator: 'IN',
        values: []
      }
    ],
    rules: {
      ruleGroups: [
        {
          ruleBlocks: [
            {
              metric: 'Retail Sales',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'Predefined Period',
                timeRange: 'Last Week'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Category',
                  concept: 'categoryid'
                }
              ],
              metricAdjustment: {
                operation: 'Divide by',
                useReferenceFilter: true,
                referenceFilters: [
                  {
                    type: 'Retailer',
                    operator: 'IN',
                    values: [],
                    concept: 'retailerid'
                  },
                  {
                    type: 'Category',
                    operator: 'IN',
                    values: [],
                    concept: 'categoryid'
                  }
                ]
              }
            },
            {
              metric: 'Retail Sales',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'Predefined Comparison',
                timeRange: 'Last Week',
                comparisonOption: 'Prior Period'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Category',
                  concept: 'categoryid'
                }
              ],
              metricAdjustment: {
                operation: 'Divide by',
                useReferenceFilter: true,
                referenceFilters: [
                  {
                    type: 'Retailer',
                    operator: 'IN',
                    values: [],
                    concept: 'retailerid'
                  },
                  {
                    type: 'Category',
                    operator: 'IN',
                    values: [],
                    concept: 'categoryid'
                  }
                ]
              }
            }
          ],
          operators: [
            {
              type: 'greater than',
              threshold: {
                value: 2,
                unit: '%'
              }
            }
          ]
        },
        {
          ruleBlocks: [
            {
              metric: 'Retail Sales',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'Predefined Period',
                timeRange: 'Last Week'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Category',
                  concept: 'categoryid'
                }
              ],
              metricAdjustment: {
                operation: 'Divide by',
                useReferenceFilter: true,
                referenceFilters: [
                  {
                    type: 'Retailer',
                    operator: 'IN',
                    values: [],
                    concept: 'retailerid'
                  },
                  {
                    type: 'Category',
                    operator: 'IN',
                    values: [],
                    concept: 'categoryid'
                  }
                ]
              }
            },
            {
              metric: 'Retail Sales',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'Predefined Comparison',
                timeRange: 'Last Week',
                comparisonOption: 'Prior Period'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Category',
                  concept: 'categoryid'
                }
              ],
              metricAdjustment: {
                operation: 'Divide by',
                useReferenceFilter: true,
                referenceFilters: [
                  {
                    type: 'Retailer',
                    operator: 'IN',
                    values: [],
                    concept: 'retailerid'
                  },
                  {
                    type: 'Category',
                    operator: 'IN',
                    values: [],
                    concept: 'categoryid'
                  }
                ]
              }
            }
          ],
          operators: [
            {
              type: 'less than',
              threshold: {
                value: 2,
                unit: '%'
              }
            }
          ]
        }
      ],
      groupOperators: [
        {
          type: 'OR'
        }
      ]
    }
  },
  notifications: {
    methods: [],
    config: {}
  }
};

export const AtlasNewKeywordJson: CreateAlertConfigType = {
  alertName: 'New Keyword',
  alertDescription: '',
  queryJSON: {
    basicInfo: {
      selectedProduct: 'atlas',
      granularity: ['RetailerId', 'BrandId', 'Searchterm'],
      frequency: 'weekly'
    },
    globalFilters: [
      {
        type: 'Category',
        concept: 'categoryid',
        operator: 'IN',
        values: []
      },
      {
        type: 'Retailer',
        concept: 'retailerid',
        operator: 'IN',
        values: []
      }
    ],
    rules: {
      ruleGroups: [
        {
          ruleBlocks: [
            {
              metric: 'Total Traffic',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'For the First Time',
                forTheFirstTimeOption: 'Last Week'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Brand',
                  concept: 'brandid'
                }
              ],
              metricFilter: {
                operator: '>'
              }
            }
          ],
          operators: []
        }
      ],
      groupOperators: []
    }
  },
  notifications: {
    methods: [],
    config: {}
  }
};

export const AtlasBrandEntersTop10TrafficJson: CreateAlertConfigType = {
  alertName: 'Brand Enters Top 10 Traffic',
  alertDescription: '',
  queryJSON: {
    basicInfo: {
      selectedProduct: 'atlas',
      granularity: ['RetailerId', 'Searchterm', 'BrandId'],
      frequency: 'weekly'
    },
    globalFilters: [
      {
        type: 'Category',
        concept: 'categoryid',
        operator: 'IN',
        values: []
      },
      {
        type: 'Retailer',
        concept: 'retailerid',
        operator: 'IN',
        values: []
      }
    ],
    rules: {
      ruleGroups: [
        {
          ruleBlocks: [
            {
              metric: 'Paid Traffic',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'Predefined Period',
                timeRange: 'Last Week'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Brand',
                  concept: 'brandid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Keyword',
                  concept: 'searchterm'
                }
              ],
              metricAdjustment: {
                operation: 'Divide by',
                useReferenceFilter: true,
                referenceFilters: [
                  {
                    type: 'Retailer',
                    operator: 'IN',
                    values: [],
                    concept: 'retailerid'
                  },
                  {
                    type: 'Keyword',
                    operator: 'IN',
                    values: [],
                    concept: 'searchterm'
                  }
                ]
              },
              metricFilter: {
                operator: 'ranked_in_top',
                rankLimit: 10
              }
            }
          ],
          operators: []
        }
      ],
      groupOperators: []
    }
  },
  notifications: {
    methods: [],
    config: {}
  }
};

export const AtlasEmergingKeywordTrendJson: CreateAlertConfigType = {
  alertName: 'Emerging Keyword Trend',
  alertDescription: '',
  queryJSON: {
    basicInfo: {
      selectedProduct: 'atlas',
      granularity: ['RetailerId', 'Searchterm'],
      frequency: 'weekly'
    },
    globalFilters: [
      {
        type: 'Category',
        concept: 'categoryid',
        operator: 'IN',
        values: []
      },
      {
        type: 'Retailer',
        concept: 'retailerid',
        operator: 'IN',
        values: []
      }
    ],
    rules: {
      ruleGroups: [
        {
          ruleBlocks: [
            {
              metric: 'Total Traffic',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'Predefined Period',
                timeRange: 'Last Week'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                }
              ]
            },
            {
              metric: 'Total Traffic',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'Predefined Comparison',
                timeRange: 'Last Week',
                comparisonOption: 'Prior Period'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                }
              ]
            }
          ],
          operators: [
            {
              type: 'greater than',
              threshold: {
                value: 50,
                unit: '%'
              }
            }
          ]
        }
      ],
      groupOperators: []
    }
  },
  notifications: {
    methods: [],
    config: {}
  }
};

export const BeaconNewProductLaunchJson: CreateAlertConfigType = {
  alertName: 'New Product Launch',
  alertDescription: '',
  queryJSON: {
    basicInfo: {
      selectedProduct: 'beacon',
      granularity: ['CategoryId', 'RetailerId', 'RetailerSku'],
      frequency: 'weekly'
    },
    globalFilters: [
      {
        type: 'Brand',
        concept: 'brandid',
        operator: 'IN',
        values: []
      },
      {
        type: 'Retailer',
        concept: 'retailerid',
        operator: 'IN',
        values: []
      }
    ],
    rules: {
      ruleGroups: [
        {
          ruleBlocks: [
            {
              metric: 'Retail Sales',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'For the First Time',
                forTheFirstTimeOption: 'Last Week'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Category',
                  concept: 'categoryid'
                }
              ],
              metricFilter: {
                operator: '>',
                value: 10000
              }
            }
          ],
          operators: []
        }
      ],
      groupOperators: []
    }
  },
  notifications: {
    methods: [],
    config: {}
  }
};

export const BeaconNewProductEntersTop10Json: CreateAlertConfigType = {
  alertName: 'New Product Enters Top 10',
  alertDescription: '',
  queryJSON: {
    basicInfo: {
      selectedProduct: 'beacon',
      granularity: ['CategoryId', 'RetailerId', 'RetailerSku'],
      frequency: 'weekly'
    },
    globalFilters: [
      {
        type: 'Brand',
        concept: 'brandid',
        operator: 'IN',
        values: []
      },
      {
        type: 'Retailer',
        concept: 'retailerid',
        operator: 'IN',
        values: []
      }
    ],
    rules: {
      ruleGroups: [
        {
          ruleBlocks: [
            {
              metric: 'Retail Sales',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'For the First Time',
                forTheFirstTimeOption: 'Last Week'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Category',
                  concept: 'categoryid'
                }
              ],
              metricFilter: {
                operator: 'ranked_in_top',
                rankLimit: 10
              }
            }
          ],
          operators: []
        }
      ],
      groupOperators: []
    }
  },
  notifications: {
    methods: [],
    config: {}
  }
};

export const BeaconSalesCrossThresholdJson: CreateAlertConfigType = {
  alertName: 'Sales Cross Threshold',
  alertDescription: '',
  queryJSON: {
    basicInfo: {
      selectedProduct: 'beacon',
      granularity: ['RetailerId', 'BrandId'],
      frequency: 'weekly'
    },
    globalFilters: [
      {
        type: 'Brand',
        concept: 'brandid',
        operator: 'IN',
        values: []
      },
      {
        type: 'Retailer',
        concept: 'retailerid',
        operator: 'IN',
        values: []
      }
    ],
    rules: {
      ruleGroups: [
        {
          ruleBlocks: [
            {
              metric: 'Retail Sales',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'Predefined Period',
                timeRange: 'Last 4 Weeks'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Brand',
                  concept: 'brandid'
                }
              ]
            },
            {
              metric: 'Retail Sales',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'Predefined Period',
                timeRange: 'Last 4 Weeks'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Brand',
                  concept: 'brandid'
                }
              ]
            }
          ],
          operators: [
            {
              type: 'greater than',
              threshold: {
                value: 0,
                unit: '$'
              }
            }
          ]
        }
      ],
      groupOperators: []
    }
  },
  notifications: {
    methods: [],
    config: {}
  }
};

export const BeaconSalesDropThresholdJson: CreateAlertConfigType = {
  alertName: 'Sale Drop Threshold',
  alertDescription: '',
  queryJSON: {
    basicInfo: {
      selectedProduct: 'beacon',
      granularity: ['RetailerId', 'BrandId'],
      frequency: 'weekly'
    },
    globalFilters: [
      {
        type: 'Brand',
        concept: 'brandid',
        operator: 'IN',
        values: []
      },
      {
        type: 'Retailer',
        concept: 'retailerid',
        operator: 'IN',
        values: []
      }
    ],
    rules: {
      ruleGroups: [
        {
          ruleBlocks: [
            {
              metric: 'Retail Sales',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'Predefined Period',
                timeRange: 'Last Week'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Brand',
                  concept: 'brandid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                }
              ]
            },
            {
              metric: 'Retail Sales',
              aggregation: 'avg',

              timeConfiguration: {
                mode: 'Predefined Period',
                timeRange: 'Last 4 Weeks'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Brand',
                  concept: 'brandid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                }
              ]
            }
          ],
          operators: [
            {
              type: 'less than',
              threshold: {
                value: 15,
                unit: '%'
              }
            }
          ]
        }
      ],
      groupOperators: []
    }
  },
  notifications: {
    methods: [],
    config: {}
  }
};

export const BeaconBrandEntersTop10SalesJson: CreateAlertConfigType = {
  alertName: 'Brand Enters Top 10 Sales',
  alertDescription: '',
  queryJSON: {
    basicInfo: {
      selectedProduct: 'beacon',
      granularity: ['RetailerId', 'BrandId'],
      frequency: 'weekly'
    },
    globalFilters: [
      {
        type: 'Brand',
        concept: 'brandid',
        operator: 'IN',
        values: []
      },
      {
        type: 'Retailer',
        concept: 'retailerid',
        operator: 'IN',
        values: []
      }
    ],
    rules: {
      ruleGroups: [
        {
          ruleBlocks: [
            {
              metric: 'Retail Sales',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'For the First Time',
                forTheFirstTimeOption: 'Last Week'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Brand',
                  concept: 'brandid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                }
              ],
              metricAdjustment: {
                operation: 'Divide by',
                useReferenceFilter: true,
                referenceFilters: [
                  {
                    type: 'Retailer',
                    operator: 'IN',
                    values: [],
                    concept: 'retailerid'
                  }
                ]
              },
              metricFilter: {
                operator: 'ranked_in_top',
                rankLimit: 10
              }
            }
          ],
          operators: []
        }
      ],
      groupOperators: []
    }
  },
  notifications: {
    methods: [],
    config: {}
  }
};

export const BeaconNewKeywordJson: CreateAlertConfigType = {
  alertName: 'New Keyword',
  alertDescription: '',
  queryJSON: {
    basicInfo: {
      selectedProduct: 'beacon',
      granularity: ['RetailerId', 'BrandId', 'Searchterm'],
      frequency: 'weekly'
    },
    globalFilters: [
      {
        type: 'Brand',
        concept: 'brandid',
        operator: 'IN',
        values: []
      },
      {
        type: 'Retailer',
        concept: 'retailerid',
        operator: 'IN',
        values: []
      }
    ],
    rules: {
      ruleGroups: [
        {
          ruleBlocks: [
            {
              metric: 'Total Traffic',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'For the First Time',
                forTheFirstTimeOption: 'Last Week'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Brand',
                  concept: 'brandid'
                }
              ],
              metricFilter: {
                operator: '>'
              }
            }
          ],
          operators: []
        }
      ],
      groupOperators: []
    }
  },
  notifications: {
    methods: [],
    config: {}
  }
};

export const BeaconBrandEntersTop10TrafficJson: CreateAlertConfigType = {
  alertName: 'Brand Enters Top 10 Traffic',
  alertDescription: '',
  queryJSON: {
    basicInfo: {
      selectedProduct: 'beacon',
      granularity: ['RetailerId', 'Searchterm', 'BrandId'],
      frequency: 'weekly'
    },
    globalFilters: [
      {
        type: 'Brand',
        concept: 'brandid',
        operator: 'IN',
        values: []
      },
      {
        type: 'Retailer',
        concept: 'retailerid',
        operator: 'IN',
        values: []
      }
    ],
    rules: {
      ruleGroups: [
        {
          ruleBlocks: [
            {
              metric: 'Paid Traffic',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'Predefined Period',
                timeRange: 'Last Week'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Brand',
                  concept: 'brandid'
                },
                {
                  operator: 'IN',
                  values: [],
                  type: 'Keyword',
                  concept: 'searchterm'
                }
              ],
              metricAdjustment: {
                operation: 'Divide by',
                useReferenceFilter: true,
                referenceFilters: [
                  {
                    type: 'Retailer',
                    operator: 'IN',
                    values: [],
                    concept: 'retailerid'
                  },
                  {
                    type: 'Keyword',
                    operator: 'IN',
                    values: [],
                    concept: 'searchterm'
                  }
                ]
              },
              metricFilter: {
                operator: 'ranked_in_top',
                rankLimit: 10
              }
            }
          ],
          operators: []
        }
      ],
      groupOperators: []
    }
  },
  notifications: {
    methods: [],
    config: {}
  }
};

export const BeaconEmergingKeywordTrendJson: CreateAlertConfigType = {
  alertName: 'Emerging Keyword Trend',
  alertDescription: '',
  queryJSON: {
    basicInfo: {
      selectedProduct: 'beacon',
      granularity: ['RetailerId', 'Searchterm'],
      frequency: 'weekly'
    },
    globalFilters: [
      {
        type: 'Brand',
        concept: 'brandid',
        operator: 'IN',
        values: []
      },
      {
        type: 'Retailer',
        concept: 'retailerid',
        operator: 'IN',
        values: []
      }
    ],
    rules: {
      ruleGroups: [
        {
          ruleBlocks: [
            {
              metric: 'Total Traffic',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'Predefined Period',
                timeRange: 'Last Week'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                }
              ]
            },
            {
              metric: 'Total Traffic',
              aggregation: 'sum',

              timeConfiguration: {
                mode: 'Predefined Comparison',
                timeRange: 'Last Week',
                comparisonOption: 'Prior Period'
              },
              categoricalfilters: [
                {
                  operator: 'IN',
                  values: [],
                  type: 'Retailer',
                  concept: 'retailerid'
                }
              ]
            }
          ],
          operators: [
            {
              type: 'greater than',
              threshold: {
                value: 50,
                unit: '%'
              }
            }
          ]
        }
      ],
      groupOperators: []
    }
  },
  notifications: {
    methods: [],
    config: {}
  }
};

// Template JSON configurations for Atlas alerts
export const AtlasAlertTemplateJSON: Record<AtlasAlertTemplateIdType, CreateAlertConfigType | undefined> = {
  'create-your-own': undefined,
  'new-product-launch': AtlasNewProductLaunchJson,
  'new-product-top-10': AtlasNewProductEntersTop10Json,
  'sales-cross-threshold': AtlasSalesCrossThresholdJson,
  'sales-drop-threshold': AtlasSalesDropThresholdJson,
  'brand-enters-top-10-sales': AtlasBrandEntersTop10SalesJson,
  'market-share-threshold': AtlasMarketShareThresholdJson,
  'market-share-change': AtlasMarketShareChangeJson,
  'new-keyword': AtlasNewKeywordJson,
  'brand-top-10-traffic': AtlasBrandEntersTop10TrafficJson,
  'emerging-keyword-trend': AtlasEmergingKeywordTrendJson,
  'your-custom-template': undefined
};

// Template JSON configurations for Beacon alerts
export const BeaconAlertTemplateJSON: Record<BeaconAlertTemplateIdType, CreateAlertConfigType | undefined> = {
  'create-your-own': undefined,
  'new-product-launch': BeaconNewProductLaunchJson,
  'new-product-top-10': BeaconNewProductEntersTop10Json,
  'sales-cross-threshold': BeaconSalesCrossThresholdJson,
  'sales-drop-threshold': BeaconSalesDropThresholdJson,
  'brand-enters-top-10-sales': BeaconBrandEntersTop10SalesJson,
  'new-keyword': BeaconNewKeywordJson,
  'brand-top-10-traffic': BeaconBrandEntersTop10TrafficJson,
  'emerging-keyword-trend': BeaconEmergingKeywordTrendJson,
  'your-custom-template': undefined
};

// Helper function to get template config by ID and platform
export const getTemplateConfigByPlatform = (
  templateId: AtlasAlertTemplateIdType | BeaconAlertTemplateIdType,
  platform: AppName.Atlas | AppName.Beacon
): Partial<CreateAlertConfigType> => {
  const templateMap = platform === AppName.Atlas ? AtlasAlertTemplateJSON : BeaconAlertTemplateJSON;
  const template = templateMap[templateId];
  return template || {};
};
